import { Configuration, PopupRequest, AuthenticationResult } from "@azure/msal-browser";

// Module-level store for the MSAL redirect result captured in main.tsx during
// initializeApp(), before React renders. MicrosoftCallbackPage consumes it once.
let _pendingRedirectResult: AuthenticationResult | null = null;

export function setPendingMsalRedirectResult(result: AuthenticationResult | null) {
  _pendingRedirectResult = result;
}

export function consumePendingMsalRedirectResult(): AuthenticationResult | null {
  const result = _pendingRedirectResult;
  _pendingRedirectResult = null;
  return result;
}

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID || "",
    authority: import.meta.env.VITE_AZURE_AD_AUTHORITY || "https://login.microsoftonline.com/organizations",
    redirectUri: import.meta.env.VITE_AZURE_AD_REDIRECT_URI || window.location.origin + "/auth/callback",
    // Prevent MSAL from auto-navigating back to the page that triggered login (/login).
    // Without this, MSAL navigates away from /auth/callback before MicrosoftCallbackPage
    // can mount and run its useEffect, so the auth exchange never happens.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    // storeAuthStateInCookie handles Edge/Safari InPrivate mode where Tracking Prevention
    // blocks storage writes — MSAL stores PKCE state in a cookie so redirect state
    // validation still works. This is the correct mitigation; localStorage must remain
    // the cache location per standards (cross-tab session sharing, no surprise logouts).
    storeAuthStateInCookie: true,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
  prompt: "select_account", // Always show account picker
};
